import React, { useEffect} from "react";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

export const Signup = () => {

  useEffect(() => {
    document.title = 'Sign up'; // Set the title to "Sign up" when this component mounts
  }, []);
  return (
    <section className="signup">
      <div className="container py-5">
        <div className="row justify-content-center py-5">
          <div className="col-lg-6">
            <div className="signup">
              <div className="text-center mb-4">
                <h3 className="f-24 fw-700">Create an Account</h3>
              </div>
              <div className="signup-form mt-5">
                <Form>
                  <Form.Group className="mb-3" controlId="formBasicFirstName">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter first name" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicLastName">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter last name" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter Email" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" placeholder="Enter Password"/>

                  </Form.Group>

                  <Button type="login" className="w-100 login-btn">
                    SIGNUP
                  </Button>

                  <div className="mt-2">
                    <Link to="/">or Return to Store</Link>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};